export default __webpack_public_path__ + "static/pottery-gang-528d474a961ffbd13a83e70b410039e8.jpg";